import { LayoutContext, defaultLayoutContext } from "../../../context/layout.context";
import { jsx as _jsx } from "react/jsx-runtime";
export var Layout = function Layout(_ref) {
  var children = _ref.children,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? defaultLayoutContext : _ref$layout;
  return /*#__PURE__*/_jsx(LayoutContext.Provider, {
    value: layout,
    children: children
  });
};